import React from 'react';
import { Container, Wrapper, Title, Desc, CardContainer } from './ProjectsStyle';
import ProjectCard from '../Cards/ProjectCards';
import { projects } from '../../data/constants';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, EffectCoverflow } from 'swiper/modules';

const Projects = ({ openModal, setOpenModal }) => {
  const [hideDesc, setHideDesc] = React.useState(false);

  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>
        {!hideDesc && (
          <Desc>
            Here are some of my projects.
          </Desc>
        )}
        <CardContainer style={{width: '100%', position: 'relative', minHeight: '520px'}}>
          {/* Left Hover Area */}
          <div
            style={{
              position: 'absolute', left: 0, top: 0, bottom: 0, width: '8%', zIndex: 3, cursor: 'pointer',
              background: 'linear-gradient(90deg, rgba(132,76,230,0.12) 0%, transparent 100%)',
              borderTopLeftRadius: '24px', borderBottomLeftRadius: '24px',
              transition: 'background 0.3s',
            }}
            onMouseEnter={() => document.querySelector('.swiper-button-prev')?.click()}
          />
          {/* Right Hover Area */}
          <div
            style={{
              position: 'absolute', right: 0, top: 0, bottom: 0, width: '8%', zIndex: 3, cursor: 'pointer',
              background: 'linear-gradient(270deg, rgba(132,76,230,0.12) 0%, transparent 100%)',
              borderTopRightRadius: '24px', borderBottomRightRadius: '24px',
              transition: 'background 0.3s',
            }}
            onMouseEnter={() => document.querySelector('.swiper-button-next')?.click()}
          />
          <Swiper
            modules={[Navigation, Pagination, EffectCoverflow]}
            navigation
            pagination={{ clickable: true }}
            effect="coverflow"
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={1}
            coverflowEffect={{
              rotate: 30,
              stretch: 0,
              depth: 120,
              modifier: 1.2,
              slideShadows: false,
            }}
            breakpoints={{
              640: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            style={{paddingBottom: '40px'}}
          >
            {projects
              .filter((item) => item.category === 'web app')
              .map((project, index) => (
                <SwiperSlide key={index}>
                  <div
                    style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}
                  >
                    <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal} />
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </CardContainer>
      </Wrapper>
    </Container>
  );
};

export default Projects;